module.exports = __webpack_public_path__ + "img/newsbg.fb38235d.jpg";